export const GET_POPULAR_SERIES = "GET_POPULAR_SERIES";
export const GET_POPULAR_SERIES_SUCCESS = "GET_POPULAR_SERIES_SUCCESS";
export const GET_TOP_RATED_SERIES = "GET_TOP_RATED_SERIES";
export const GET_TOP_RATED_SERIES_SUCCESS = "GET_TOP_RATED_SERIES_SUCCESS";
export const GET_SERIES_DETAILS = "GET_SERIES_DETAILS";
export const GET_SERIES_DETAILS_SUCCESS = "GET_SERIES_DETAILS_SUCCESS";
export const GET_SERIES_CREDITS = "GET_SERIES_CREDITS";
export const GET_SERIES_CREDITS_SUCCESS = "GET_SERIES_CREDITS_SUCCESS";
export const GET_SERIES_IMAGES = "GET_SERIES_IMAGES";
export const GET_SERIES_IMAGES_SUCCESS = "GET_SERIES_IMAGES_SUCCESS";
export const GET_SERIES_VIDEOS = "GET_SERIES_VIDEOS";
export const GET_SERIES_VIDEOS_SUCCESS = "GET_SERIES_VIDEOS_SUCCESS";
export const GET_SERIES_REVIEWS = "GET_SERIES_REVIEWS";
export const GET_SERIES_REVIEWS_SUCCESS = "GET_SERIES_REVIEWS_SUCCESS";
export const GET_SERIES_RECOMMENDATIONS = "GET_SERIES_RECOMMENDATIONS";
export const GET_SERIES_RECOMMENDATIONS_SUCCESS = "GET_SERIES_RECOMMENDATIONS_SUCCESS";
export const GET_SERIES_SIMILAR = "GET_SERIES_SIMILAR";
export const GET_SERIES_SIMILAR_SUCCESS = "GET_SERIES_SIMILAR_SUCCESS";